/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { SortOrder, TableColumn } from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';

import { DefaultTable } from 'src/components';
import { useActions } from 'src/hooks/useActions';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IEmployee } from 'src/interfaces/employee';
import { Container } from './styles';

export const EmployeeListTable: React.FC<{
  searchTerm: string;
  columns: TableColumn<any>[];
  employeeStatus: string;
  companyId: string;
  selectableRows?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSelectedRowsChange?: (selected: { allSelected: boolean; selectedCount: number; selectedRows: IEmployee[] }) => void;
  enableGlobalSearch?: boolean;
}> = ({
  searchTerm,
  columns,
  employeeStatus,
  companyId,
  selectableRows = false,
  onSelectedRowsChange,
  enableGlobalSearch = false,
}) => {
  const navigate = useNavigate();
  const { employees, totalEmployees } = useTypedSelector(state => state.employees.data);
  const { loading } = useTypedSelector(state => state.employees);
  const { getEmployees, setSelectedEmployee } = useActions();
  const [data, setData] = useState<IEmployee[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('firstName');
  const [sortDirection, setSortDirection] = useState('');
  const { config } = useTypedSelector(state => state.config.data);

  const { patchConfig } = useActions();

  useEffect(() => {
    getEmployees({
      page: 1,
      companyId,
      limit,
      employeeStatus,
      search: searchTerm,
      sortBy,
      sortDirection,
      allCompanies: enableGlobalSearch,
    });
  }, [searchTerm, employeeStatus, enableGlobalSearch]);

  useEffect(() => {
    setData(employees);
    setTotalRows(totalEmployees);
  }, [employees]);

  const fetchUsers = async (page: number) => {
    getEmployees({
      page,
      companyId,
      limit,
      employeeStatus,
      sortBy,
      sortDirection,
      search: searchTerm,
    });
  };

  const handlePageChange = (page: number) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newLimit: number, page: number) => {
    getEmployees({
      page,
      companyId,
      limit: newLimit,
      employeeStatus,
      sortBy,
      sortDirection,
      search: searchTerm,
    });

    setLimit(newLimit);
  };

  const handleRowClicked = async (row: IEmployee) => {
    setSelectedEmployee(row);
    patchConfig({ ...config, selectedCompanyId: row.companyId });
    navigate('/employee', { replace: true });
  };

  const handleSort = async (column: TableColumn<IEmployee>, newSortDirection: SortOrder) => {
    getEmployees({
      page: 1,
      companyId,
      limit,
      employeeStatus,
      sortBy: column.sortField as unknown as string,
      sortDirection: newSortDirection,
    });
    setSortBy(column.sortField as unknown as string);
    setSortDirection(newSortDirection);
  };

  useEffect(() => {
    fetchUsers(1);
  }, [companyId]);

  return (
    <Container>
      <DefaultTable
        columns={columns}
        data={data}
        onRowClicked={handleRowClicked}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        onSort={handleSort}
        sortServer
        selectableRows={selectableRows}
        onSelectedRowsChange={onSelectedRowsChange}
      />
    </Container>
  );
};
